import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import IconFilter from '../../images/filter_icon.png';
import SortDown from '../../images/sort-down.png';
import SortUp from '../../images/sort-up.png';
import CloseFilter from '../../images/close_icon.png';

import ModalFilterAndSort from '../Modals/ModalFilterAndSort';

import { getAllBrands, getAllSizes } from '../../actions/filterAction';
import { doSetFilterSearch, doSetSortBySearch } from "../../actions/uiAction";

import {
  Container,
  Row,
  Col,
  Modal,
  Button
} from 'reactstrap';

import { sortingSearchResultAPI, doFetchPopularSearch, fetchCollectionProduct, saveCollectionSort } from '../../actions/productAction';
import FilterDropdown from './FilterDropdown';
import { getQueryParamsUrl } from "../../helpers/url";
import SelectedFilter from './SelectedFilter';

class FilterAndSort extends React.Component {
  filterWrapperRef = React.createRef();
  sortWrapperRef = React.createRef();

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      sortOpen: false,
      filterOpen: false,
      modal: false,
      currentSort: 'MOST_POPULAR',
      isBrandExpanded: false,
      isChildBrandExpanded: false,
      isSizeExpanded: false,
      isConditionExpanded: false,
      isPriceExpanded: false,
      activeSize: 'maleSizes',
      activeApparelsSize: 'topSizes',
      selectedBrands: [],
      selectedSizes: {
        maleSizes: [],
        femaleSizes: [],
        kidSizes: []
      },
      activeConditions: '',
      minPrice: '',
      maxPrice: '',
      alreadySorted: false,
      activeGender: ''
    };
    this.toggleModalSearch = this.toggleModalSearch.bind(this);
    this._handleSorting = this._handleSorting.bind(this);
  }

  toggle() {
    this.props.setSortBy(!this.props.isSortOpen);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    const { selected } = this.props.dataCategory;
    if (prevProps.dataCategory.selected != selected) {
      const query = { params: { category: selected } }
      this.setState({
        filterOpen: false,
        selectedBrands: [],
        selectedSizes: {
          maleSizes: [],
          femaleSizes: [],
          kidSizes: []
        }
      }, () => {
        this.props.getAllBrands(query);
        this.props.getAllSizes(query);
        this.props.getPopularSearch(query);
      });
    }

    // Handler for UI sort dropdown
    // By default there are only 2 condition for sorting: most popular and best match
    if (prevProps.isSortOpen !== this.props.isSortOpen && this.props.isSortOpen) {
      // if (!this.state.alreadySorted) {
      //   const params = getQueryParamsUrl(this.props.history.location);
      //   const arrParams = params.pathname.split('/');
      //   this.setState({
      //     // currentSort: arrParams[arrParams.length - 1] === 'browse+all' ? 'MOST_POPULAR' : '',
      //     currentSort: "MOST_POPULAR",
      //     alreadySorted: true,
      //   });
      // } else {
        const { caseSorting } = this.props.dataProduct;
        // let sort = caseSorting === "" ? '' : caseSorting;
        
        const arr = [
          { label: 'FEATURED', value: 'featured' },
          { label: 'MOST_POPULAR', value: 'most_popular' },
          { label: 'BEST_MATCH', value: '' },
          { label: 'MIN_MAX', value: 'price_asc' },
          { label: 'MAX_MIN', value: 'price_desc' },
        ]
        
        const currentSort = arr.find(item => item.value === caseSorting);

        this.setState({
          currentSort: currentSort ? currentSort.label : ''
        });
      // }
    }

    // If user change the sort manually
  //   if (
  //     prevProps.dataProduct.caseSorting !== this.props.dataProduct.caseSorting &&
  //     this.props.dataProduct.caseSorting !== this.state.currentSort
  //   ) {
  //     const { caseSorting } = this.props.dataProduct;
  //     let sort = caseSorting === "" ? 'latest' : caseSorting;

  //     const arr = [
  //       { label: 'FEATURED', value: 'featured' },
  //       { label: 'MOST_POPULAR', value: 'most_popular' },
  //       { label: 'TERBARU', value: 'latest' },
  //       { label: 'MIN_MAX', value: 'price_asc' },
  //       { label: 'MAX_MIN', value: 'price_desc' },
  //     ]

  //     const currentSort = arr.find(item => item.value === sort);
  //     this.setState({
  //       currentSort: currentSort ? currentSort.label : ''
  //     });
  //   }
  }

  /**
     * Alert if clicked on outside of element
     */
  handleClickOutside = (event) => {
    if (this.filterWrapperRef.current && !this.filterWrapperRef.current.contains(event.target)) {
      if (this.props.isFilterOpen) {
        this.props.setFilter(!this.props.isFilterOpen);
      }
    }
    if (this.sortWrapperRef.current && !this.sortWrapperRef.current.contains(event.target)) {
      if (this.props.isSortOpen) {
        this.props.setSortBy(!this.props.isSortOpen);
      }
    }
  }

  toggleFilter = () => {
    const { selected } = this.props.dataCategory;
    if (this.props.isFilterOpen == false) {
      const query = {
        params: { category: selected }
      }
      this.props.getAllBrands(query)
      this.props.getAllSizes(query)
    }
    this.props.setFilter(!this.props.isFilterOpen);
  }

  _handleSorting(caseSort, sort_params) {
    const { selected } = this.props.dataCategory;
    const { search } = this.props.history.location;
    let paramsRoute = search !== '' ? search.slice(1) : '';
    let searchKeywordFilter = this.props.match.params.keyword === undefined ? '' : this.props.match.params.keyword.toUpperCase().replace(/\+/g, ' ').trim();

    if (this.props.typeFilter === 'NEVER_TOO_LAVISH') {
      this.props.sortingSearchResultAPI(paramsRoute, {
        params: {
          collection: 'never-too-lavish',
          category: selected,
          sort_by: sort_params,
          page: 1,
          per_page: 52,
          availables: true
        }
      }, '');
    } else {
      if (searchKeywordFilter.toUpperCase() === 'BROWSE ALL' || searchKeywordFilter.toUpperCase() === 'BROWSE+ALL') {
        // console.log('KOSONG')
        this.props.sortingSearchResultAPI(paramsRoute, {
          params: {
            sort_by: sort_params,
            category: selected,
            page: 1,
            per_page: 52,
            availables: true
          }
        }, '');
      } else {
        // console.log('ISI')
        this.props.sortingSearchResultAPI(paramsRoute, {
          params: {
            sort_by: sort_params,
            category: selected,
            keyword: searchKeywordFilter,
            page: 1,
            per_page: 52,
            availables: true
          }
        }, '');
      }
    }
    if (this.props.onResetPageNumber) this.props.onResetPageNumber()
  }

  _handleSortingCollection = (caseSort, sort_params) => {
    const { selected } = this.props.dataCategory;
    const { search } = this.props.history.location;
    const queries = getQueryParamsUrl(search);
    const { isPreVerified, dataProduct: { collection: { slug, collectionType }} } = this.props;

    let payload = {
      ...queries,
      sort_by: sort_params,
      page: 1,
      availables: true,
      collection: slug,
      collection_type: collectionType,
      category: selected
    }

    if (isPreVerified) payload.pre_verified = true

    this.props.fetchCollectionProduct(payload, search);
    this.props.saveCollectionSort(sort_params);
  }

  renderSortDropdown() {
    let searchKeywordFilter = this.props.match.params.keyword === undefined ? 'BROWSE ALL' : this.props.match.params.keyword.toUpperCase().replace(/\+/g, ' ').trim();
    const { search } = this.props.history.location;
    const { currentSort } = this.state;

    return (
      <div ref={this.sortWrapperRef} id={'filter-sort'} className="container__drop_down show__option sort__dropdown__wrapper">
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{fontFamily: currentSort === 'MOST_POPULAR' ?"Nunito-Bold" : "Nunito-Regular"}}
            onClick={() => {
              this.setState({
                currentSort: 'MOST_POPULAR'
              })
              !this.props.isCollectionPage? this._handleSorting('MOST_POPULAR', 'most_popular') : this._handleSortingCollection('MOST_POPULAR', 'most_popular')
              this.toggle()
            }}
            >Most Popular</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{fontFamily: currentSort === "BEST_MATCH" ?"Nunito-Bold" : "Nunito-Regular"}}
            onClick={() => {
              this.setState({
                currentSort: "BEST_MATCH"
              })
              !this.props.isCollectionPage? this._handleSorting("BEST_MATCH", "") : this._handleSortingCollection("BEST_MATCH", "")
              this.toggle()
            }}
            >Best Match</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{fontFamily: currentSort === 'MAX_MIN' ?"Nunito-Bold" : "Nunito-Regular"}}
            onClick={() => {
              this.setState({
                currentSort: 'MAX_MIN'
              })
              !this.props.isCollectionPage? this._handleSorting('MAX_MIN', 'price_desc') : this._handleSortingCollection('MAX_MIN', 'price_desc')
              this.toggle()
            }}
            >Highest to Lowest</Button>
        </div>
        <div className="wrapping__btn btn-sort items__show">
          <Button
            style={{fontFamily: currentSort === 'MIN_MAX' ?"Nunito-Bold" : "Nunito-Regular"}}
            onClick={() => {
              this.setState({
                currentSort: 'MIN_MAX'
              })
              !this.props.isCollectionPage? this._handleSorting('MIN_MAX', 'price_asc') : this._handleSortingCollection('MIN_MAX', 'price_asc')
              this.toggle()
            }}
            >Lowest to Highest</Button>
        </div>
      </div>
    )
  }



  toggleModalSearch() {
    if (this.state.modal == false) {
      this.props.getAllBrands()
      this.props.getAllSizes()
    }
    this.setState({
      modal: !this.state.modal
    });

  }

  updateState = (key, val, unselectable = false) => {
    if (!unselectable)
      this.setState({ [key]: val })

    else {
      this.setState({
        [key]: this.state[key] === val ? '' : val //clear if the value is already selected
      })
    }
  }

  onSaveLastState = (activeSize, activeApparelsSize, selectedBrands, selectedSizes, activeConditions, minPrice, maxPrice, activeGender) => {
    this.setState({
      activeSize,
      activeApparelsSize,
      selectedBrands,
      selectedSizes,
      activeConditions,
      minPrice,
      maxPrice, 
      activeGender
    })
  }

  renderFilterDropdown() {
    return (
      <div ref={this.filterWrapperRef}>
        <FilterDropdown
          history={this.props.history}
          match={this.props.match}
          onClose={this.toggleFilter}
          updateState={(key, val, unselectable = true) => this.updateState(key, val, unselectable = true)}
          isBrandExpanded={this.state.isBrandExpanded}
          isChildBrandExpanded={this.state.isChildBrandExpanded}
          isSizeExpanded={this.state.isSizeExpanded}
          isConditionExpanded={this.state.isConditionExpanded}
          isPriceExpanded={this.state.isPriceExpanded}
          activeSize={this.state.activeSize}
          activeApparelsSize={this.state.activeApparelsSize}
          selectedBrands={this.state.selectedBrands}
          selectedSizes={this.state.selectedSizes}
          activeConditions={this.state.activeConditions}
          minPrice={this.state.minPrice}
          maxPrice={this.state.maxPrice}
          onSaveLastState={this.onSaveLastState}
          dataCategory={this.props.dataCategory}
          isOpen={this.props.isFilterOpen}
          isCollectionPage={this.props.isCollectionPage}
          isPreVerified={this.props.isPreVerified}
          slug={this.props.slug}
          collectionType={this.props.collectionType}
          activeGender={this.state.activeGender}
        />
      </div>
    )
  }
  
  /*
    render modal Filter
  */
  renderModalFilter() {
    return (
      <ModalFilterAndSort
        active={this.state.modal}
        toggleModalSearch={this.toggleModalSearch.bind(this)}
        history={this.props.history}
        match={this.props.match}
        typeFilter={this.props.typeFilter}
      />
    )
  }

  currentSort = (sort) => {
    switch(sort) {
      case "MOST_POPULAR":
        return "Most Popular"
      case "BEST_MATCH":
        return "Best Match"
      case "MAX_MIN":
        return "Highest to Lowest"
      case "MIN_MAX":
        return "Lowest to Highest"
      default: 
        return "Most Popular"
    }
  }

  filterCondition = (key, value) => {
    const params = getQueryParamsUrl(this.props.history.location.search);
    let { brands } = this.props.dataFilter;
      
    if(key === "brands") {
      const selectedBrand = brands.find(brand => brand.id === value);
      return `${selectedBrand && selectedBrand.name}`
    } else if(key === "sneakersCondition") {
      switch(value) {
        case "new":
          return "Brand New"
        case "pristine":
          return "Pristine"
        case "good":
          return "Good"
        case "well_used":
          return "Well Used"
        case "like_new":
          return "Like New"
        case "vintage":
          return "Vintage"
        case "used":
          return "Used"
        case "pre_order":
          return "Pre Order"
        case "pre_verified":
          return "Pre Verified"
      }
    } else if(key === "sex") {
      switch(value) {
        case "M":
          return "Men"
        case "F":
          return "Women"
        case "Y":
          return "Youth"
      }
    } else if(key === "color") {
      switch(value) {
        case "red":
          return "Red"
        case "black":
          return "Black"
        case "blue":
          return "Blue"
        case "white":
          return "White"
        case "green":
          return "Green"
        case "brown":
          return "Brown"
        case "yellow":
          return "Yellow"
        case "gray":
          return "Gray"
        case "gold":
          return "Gold"
        case "pink":
          return "Pink"
        case "purple":
          return "Purple"
      }
    } else if(key === "startPrice") {
      return `IDR ${value} - ${params.endPrice}`
    } else if(key === "endPrice") {
      return `IDR ${params.endPrice} - ${value}`
    } else if(key === "sizeTypes") {
      switch(value) {
        case "M":
          return `US Men ${params.sizes}`
        case "F":
          return `US Women ${params.sizes}`
        case "Y":
          return `US Youth ${params.sizes}`
      }
    } else {
      return null
    }
  }

  render() {
    const params = getQueryParamsUrl(this.props.history.location.search);
    const arrayOfObj = Object.keys(params).map((key) => [(key), params[key]]);

    let { brands } = this.props.dataFilter;
    const selectedBrand = brands.find(brand => brand.id === 1);

    return (
      <Container className="is-mobile filter__sort__wrapper">
        {
          this.renderModalFilter()
          // this.renderFilterDropdown()
        }
        <Row className="filter__sort__product">

          {/* <Col className="border__btn__bottom" md="3" xs="2">
          </Col>
          <Col className="border__btn__bottom" md="3" xs="2">
          </Col> */}
          <Col style={{ padding: 0 }} lg="1" md="2" sm="2" xs="3" className="border__btn__bottom btn__filter">
            {
              this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span><KickImage className="filter__icon" src={IconFilter} alt=""/> Filter <i className="fa fa-angle-left"></i></span>
              </div>
            }
            {
              !this.props.isFilterOpen &&
              <div onClick={this.toggleFilter} className="wrapping__btn btn-filter">
                <span>Filter <i className="fa fa-angle-right"></i></span>
              </div>
            }

              {/* <div className="box__icon">
              <KickImage className="filter__icon" src={IconFilter} alt=""/>
            </div> */}

            
            {/* {
              this.props.isFilterOpen === true ?
              this.renderFilterDropdown()
              :
              null
            } */}
            {this.renderFilterDropdown()}
            

          </Col>
          {/* <Col style={{ padding: 0 }} lg="9" md="8" sm="8" xs="7" className={"selected-sort-filter"}>
            <Row className="scroll-wrapper">
              <SelectedFilter/>
              {
                this.props.match.params.keyword && 
                <div className="selected-button keywword">
                  <span>Search: {this.props.match.params.keyword} <KickImage onClick={() => this.removeFilter()} className="close__icon" src={CloseFilter} alt=""/></span>
                </div>
              }

              <div className="selected-button">
                <span>{this.props.match.params.category} <KickImage onClick={this.removeFilter()}className="close__icon" src={CloseFilter} alt=""/></span>
              </div>
                {
                  arrayOfObj.map((item, index) => {
                    return (
                      <div className="selected-button">
                        <span>{this.filterCondition(item[0], item[1])} <KickImage onClick={this.removeFilter()} className="close__icon" src={CloseFilter} alt=""/></span>
                      </div>
                    )
                  })
                }
            </Row>
          </Col> */}

          
          <Col style={{ padding: 0 }} lg="2" md="2" sm="2" xs="2" className={`border__btn__bottom btn__sort`}>
            {/* <div
              onClick={() => this.toggleModalSearch() }
              onClick={this.toggleFilter}
              className="wrapping__btn btn-filter border__btn__bottom"> */}
              {/* <span onClick={() => this.toggle() }>Sort By <i className="fa fa-angle-right"></i></span> */}

              {/* <div className="box__icon">
                <KickImage className="filter__icon" src={this.props.isSortOpen ? SortUp : SortDown} alt=""/>
              </div>*/}
              {
                this.props.isSortOpen &&
                <div className="wrapping__btn btn-sort border__btn__bottom"  onClick={this.toggle}>
                  <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span><i className="fa fa-angle-up"></i></p>
                </div>
              }
              {
                !this.props.isSortOpen &&
                <div className="wrapping__btn btn-sort border__btn__bottom" onClick={this.toggle}>
                  <p>Sort: <span>{this.currentSort(this.state.currentSort)} </span><i className="fa fa-angle-down"></i></p>
                </div>
              }
            {
              this.props.isSortOpen === true ?
                this.renderSortDropdown()
                :
                null
            }
          </Col>


        </Row>
      </Container>
    )
  }

}

const mapStateToProps = state => ({
  dataProduct: state.dataProduct,
  dataCategory: state.dataCategory,
  isSortOpen: state.dataUi.isSortOpen,
  isFilterOpen: state.dataUi.isFilterOpen,
  dataFilter: state.filterReducer
})

const mapDistpatchToProps = dispatch => {
  return {
    sortingSearchResultAPI: (paramsRoute, caseSort, status_action) => dispatch(sortingSearchResultAPI(paramsRoute, caseSort, status_action)),
    getAllBrands: (query) => dispatch(getAllBrands(query)),
    getAllSizes: (query) => dispatch(getAllSizes(query)),
    getPopularSearch: (query) => dispatch(doFetchPopularSearch(query)),
    setSortBy: payload => dispatch(doSetSortBySearch(payload)),
    setFilter: payload => dispatch(doSetFilterSearch(payload)),
    fetchCollectionProduct: (payload, paramsRoute) => dispatch(fetchCollectionProduct(payload, paramsRoute)),
    saveCollectionSort: (sort_by) => dispatch(saveCollectionSort(sort_by))
  }
}

export default connect(mapStateToProps, mapDistpatchToProps)(FilterAndSort);
